<template>
  <ModalDefault modal_id="addCampaignGroupModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                class_form="modal-height"
                :modal_header="getTranslations('expression_1221')"
                :footer="!groups.modal_loading"
                icon="bx bx-book-open mr-1">
    <!--style_body="max-height: 32rem;"-->
    <div v-if="!groups.modal_loading" class="px-4 py-2 pb-3" slot="body">
      <section >
        <!--1 row-->
        <div class="row d-flex align-items-center mb-4">
          <div v-if="!groups.field_new_group" class="animated--fade-in p-0" style="width: 100%">

            <div v-if="!groups.edit_group.id" class="p-2 mb-4 shadow-sm" role="alert"
                 style="background-color: rgba(219, 234, 254, 1); border-top-width: 4px; border-color: rgba(59, 130, 246, 1); color: rgba(30, 58, 138, 1); border-bottom-right-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
              <div class="d-flex">
                <div>
                  <p style="font-weight: 700;">{{ getTranslations('expression_1239') }}</p>
                  <p style="font-size: 0.875rem; line-height: 1.25rem;">
                    {{ getTranslations('expression_1237') }}
                  </p>
                </div>
              </div>
            </div>

            <div v-if="groups.data.length >= 1">
              <label class="mb-0">{{ getTranslations('expression_1222') }} </label>
              <div class="input-group">
                <!--Select Group-->
                <select v-model="groups.edit_group.id" @change="groups.edit_group.id ? setGroup(groups.edit_group.id) : setGroup(null)" class="input_forms custom-select pl-50" style="min-width: 200px;">
                  <option :value="null">{{ getTranslations('expression_1231') }}</option>
                  <option v-for="group in groups.data" :key="group.id" :value="group.id" v-show="getGroupsAvaible(group.channels)">{{ group.name }}</option>
                </select>
                <!--Excluir grupo-->
                <span v-if="groups.edit_group.id"
                      @click.prevent="deleteGroup(groups.edit_group.id)"
                      v-b-tooltip.bottom
                      :title="getTranslations('expression_1224')"
                      class="btn btn-white rounded-circle mx-2" style="width: 35px; height: 35px">
              <i class='bx bx-trash m-0 p-0'></i>
              </span>
                <!--Button New Group-->
                <span @click.prevent="iconNewGroup"
                      v-b-tooltip.bottom
                      :title="getTranslations('expression_1220')"
                      class="btn btn-white rounded-circle" style="width: 35px; height: 35px">
                <i class='bx bx-folder-plus m-0 p-0'></i>
              </span>
              </div>
            </div>

            <div v-else style="display: flex; align-items: center; flex-direction: column">
              <img style="width: 20rem; margin-right: 4rem;" :src="group_campaign" alt="">

              <div>
                <button @click.prevent="iconNewGroup" class="btn btn-secondary" style="display: flex; align-items: center;">
                  <i class='bx bx-plus m-0 p-0'></i>
                  <span class="ml-2">{{ getTranslations('expression_1230') }}</span>
                </button>
              </div>
            </div>

          </div>
          <!--Field New Group-->
          <div v-if="groups.field_new_group" class="animated--fade-in p-0" style="width: 100%">
            <label class="mb-0">{{ getTranslations('expression_1228') }} </label>
            <div class="input-group">
              <input type="text" v-model="groups.new_group.name" class="input_forms form-control" style="z-index: 1" maxlength="40">
              <TextCount :length="groups.new_group && groups.new_group.name ? groups.new_group.name.length : 0" limit="40" hidden_text="true" input_style="font-size: .75rem; position: absolute;right: 75px;top: 14px;z-index: 2"/>
              <span @click.prevent="iconBackEdit" class="ml-2 align-self-end cursor-pointer text-cancel" :title="getTranslations('expression_355')">{{ getTranslations('expression_355') }}</span>
            </div>
          </div>
        </div>

        <!--2 row-->
        <!--Field Edit Group-->
        <div v-if="groups.field_edit_group && groups.edit_group.id" class="row d-flex align-items-center animated--fade-in mb-4 mt-2">
          <div class="p-0 mb-2" style="width: 100%">
            <label class="mb-0">{{ getTranslations('expression_1232') }}</label>
            <div class="input-group">
              <input type="text" v-model="groups.edit_group.name" class="input_forms form-control" style="z-index: 1" maxlength="40">
              <TextCount :length="groups.edit_group && groups.edit_group.name ? groups.edit_group.name.length : 0" limit="40" hidden_text="true" input_style="font-size: .75rem; position: absolute;right: 0;top: 14px;z-index: 2"/>
            </div>
          </div>
        </div>

        <!--3 row-->
        <div v-if="groups.edit_group.id || groups.field_new_group" class="animated--fade-in row" style="margin-left: -1.5rem; margin-right: -1.5rem;">
          <!--Canais Vinculados-->
          <div class="d-flex justify-content-between px-2 cursor_default text-left ellipsis" style="width: 100%">
            <div class="pt-1 ellipsis">
              <span class="title-color d-flex" style="font-family: 'Product Sans Medium Regular'; font-size: 1.2rem;">
              <span class="cursor_default ml-0 pl-0 ellipsis">{{ getTranslations('expression_1000') }}</span>
              <span class="hidden-sm">
                <i style="font-size: .9rem"
                   v-b-tooltip.right
                   :title="getTranslations('expression_1001')"
                   class="ml-2 bx bx-info-circle"></i>
              </span>
            </span>
              <small>{{ getTranslations('expression_1240') }}</small>
            </div>
            <div class="d-flex">
              <div class="ellipsis mt-1 hidden-sm">
                <small v-if="getChannelsFilterNoOfficialAndAvailableArray().length > 0" class="mt-2 mr-2 ellipsis">
                  {{ channels.data.length > 1
                  ? `${getChannelsFilterNoOfficialAndAvailableArray().length} ${getTranslations('expression_1225')}`
                  : `${getChannelsFilterNoOfficialAndAvailableArray().length} ${getTranslations('expression_117')}` }}
                </small>
              </div>
            </div>
          </div>

          <!--Channels-->
          <div class="animated--fade-in row mt-3 mx-2">
            <div class="text-center pb-2" style="display: contents;">
              <div v-for="channel in getChannelsFilterNoOfficialAndAvailableArray()" :key="channel.id" class="pr-4 mb-4">
                <div v-b-tooltip.top
                     :title="getChannelObject('id', channel.id).name"
                     style="justify-content: left; align-self: center;"
                     class="px-3 d-flex bg-light shadow-sm cursor_default text-left ellipsis">
                  <div class="pt-2 pb-2 ellipsis">
                    <div class="custom-control d-flex cursor_pointer custom-switch ellipsis">
                      <!--Channels edit group-->
                      <input v-if="groups.field_edit_group && groups.edit_group.id"
                             type="checkbox"
                             @change="changeEditGroupChannel(channel.id)"
                             :checked="groups.edit_group.channels.includes(channel.id)"
                             class="custom-control-input ellipsis cursor_pointer"
                             :id="`channels_${channel.id}`">
                      <!--Channels new group-->
                      <input v-if="groups.field_new_group"
                             type="checkbox"
                             @change="changeNewGroupChannel(channel.id)"
                             :checked="groups.new_group.channels.includes(channel.id)"
                             class="custom-control-input ellipsis cursor_pointer"
                             :id="`channels_${channel.id}`">
                      <label class="custom-control-label cursor_pointer pt-1 pl-50 ml-2 mr-2" :for="`channels_${channel.id}`">
                        <span class="ellipsis ml-1">{{ (channel.name ? channel.name : '---') | truncate(20) }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!--Loading-->
    <section v-if="groups.modal_loading" slot="body" style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%">
      <div class="row animated--fade-in mt-3">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <div class="spinner-border text--primary" style="width: 3.5rem; height: 3.5rem;" role="status"></div>
            </div>
            <div class="col-12 text-center cursor_default">
              <small class="bx-flashing">
                {{ getTranslations('expression_36') }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div slot="footer" class="d-flex">
        <!--Fechar-->
        <button data-dismiss="modal" class="d-flex align-items-center btn-secondary text-white cursor_pointer shadow-sm py-2 px-3 mr-2">
          <span>{{ getTranslations('expression_340') }}</span>
        </button>
<!--      <div>
          <span data-dismiss="modal" class="shadow-sm cursor_pointer btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_340') }}</span>
          </span>
      </div>-->
        <!--Criar-->
        <button v-if="groups.field_new_group" @click.prevent="addNewGroup"
                :disabled="(groups.new_group.name && groups.new_group.name.length === 0 || groups.new_group.name === null || groups.new_group.name === '')
                || (groups.new_group.channels && groups.new_group.channels.length === 0)"
                class="d-flex align-items-center btn-primary text-white cursor_pointer shadow-sm py-2 px-3"
                :class="(groups.new_group.name && groups.new_group.name.length === 0 || groups.new_group.name === null || groups.new_group.name === '')
                || (groups.new_group.channels && groups.new_group.channels.length === 0) ? 'bg-blue-200' : ''">
        <i class="bx bx-plus"></i>
        <span class="ml-2">{{ getTranslations('expression_1230') }}</span>
      </button>
        <!--Salvar-->
        <button v-if="groups.field_edit_group" @click.prevent="updatedGroup(groups.edit_group)"
                :disabled="(groups.edit_group && groups.edit_group.name && groups.edit_group.name.length === 0 || groups.edit_group.name === '')
                || (groups.edit_group.channels && groups.edit_group.channels.length === 0)"
                class="d-flex align-items-center btn-primary text-white cursor_pointer shadow-sm py-2 px-3"
                :class="(groups.edit_group && groups.edit_group.name && groups.edit_group.name.length === 0 || groups.edit_group.name === '')
                || (groups.edit_group.channels && groups.edit_group.channels.length === 0) ? 'bg-blue-200' : ''">
        <i class="bx bx-save"></i>
        <span class="ml-2">{{ getTranslations('expression_240') }}</span>
      </button>
      </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import Swal from "sweetalert2";
import groups from "../../store/modules/groups";
import TextCount from "../general/TextCount";
import Loader from "../general/Loader";
import addGroupImage from "../../../../public/images/add-group.png";

export default {
  name: "ModalAddCampaignGroup",
  components: {
    Loader,
    TextCount,
    ModalDefault,
  },
  created() {
    this.loadResources();
  },
  computed: {
    ...mapState(['groups']),
    ...mapGetters([
      'getGroupsArray',
      'getGroupObject',
    ]),
  },
  data() {
    return {
      group_campaign: addGroupImage
    }
  },
  methods: {
    addNewGroup() {
      this.$store.dispatch('addGroup', this.groups.new_group)
      this.$store.dispatch('startModalLoading')
    },
    updatedGroup(payload) {
      this.$store.dispatch('updateGroup', payload)
      this.$store.dispatch('startModalLoading')
    },
    deleteGroup(payload) {
      this.$swal.fire({
        title: this.getTranslations('expression_1229'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit('SET_FIELD_EDIT_GROUP', false)
          this.$store.dispatch('deleteGroup', payload)
          this.$store.dispatch('startModalLoading')
        }
      })
    },

    iconNewGroup() {
      this.$store.commit('SET_FIELD_NEW_GROUP', true)
      this.$store.commit('SET_FIELD_EDIT_GROUP', false)
    },
    iconBackEdit() {
      if(this.groups.data.length === 0) {
        this.$store.commit('SET_FIELD_EDIT_GROUP', false)
      } else {
        this.$store.commit('SET_FIELD_EDIT_GROUP', true)
      }
      this.$store.commit('SET_FIELD_NEW_GROUP', false)
      this.$store.commit('SET_NEW_GROUP', { channels: [], name: null})
      // this.$store.dispatch('startLoading')
    },
    async loadResources() {
      // await this.$store.dispatch("getGroups")
    },
    async setGroup(group_id) {
      if(group_id !== null) {
        await this.$store.commit('SET_EDIT_GROUP', this.xeroxHelper(this.getGroupObject('id', group_id)))
        await this.$store.commit('SET_FIELD_EDIT_GROUP', true)
      } else {
        await this.$store.commit('SET_EDIT_GROUP', {id: null, name: null, channels: []})
        await this.$store.commit('SET_FIELD_EDIT_GROUP', false)
      }
    },
    /*Edit Group Chanel*/
    changeEditGroupChannel(payload) {
      if(this.groups.edit_group.channels.includes(payload)){
        const key = this.groups.edit_group.channels.findIndex(channel_id => {
          return channel_id === payload
        })
        this.groups.edit_group.channels.splice(key, 1)
      } else {
        this.groups.edit_group.channels.push(payload)
      }
    },
    /*Canais da aba new_group*/
    changeNewGroupChannel(payload) {
      if (this.groups.new_group.channels.includes(payload)) {
        const key = this.groups.new_group.channels.findIndex(channel_id => {
          return channel_id === payload
        })
        this.groups.new_group.channels.splice(key, 1)
      } else {
        this.groups.new_group.channels.push(payload)
      }
    },
    getGroupsAvaible(payload) {
      let have = false;
      payload.forEach(channel_id => {
        if(this.channels.data.find(channel => channel.id === channel_id)) {
          have = true;
        }
      });
      return have;
    }
  }
}
</script>

<style >
.text-cancel:hover {
  color: #797979;
}
@media (max-width: 768px)
{
  .modal-height {
    height: 100%;
  }
}
@media (min-width: 768px)
{
  .modal-height {
    min-height: 32.5rem;
    max-height: 32.5rem;
  }
}
.bg-blue-200, .bg-blue-200:hover{
  background-color: #7590de!important;
}
</style>
